export const GET_POLICY_EXTERNAL_LINKS_API_REQUEST = 'GET_POLICY_EXTERNAL_LINKS_API_REQUEST';
export const GET_POLICY_EXTERNAL_LINKS_API_SUCCESS = 'GET_POLICY_EXTERNAL_LINKS_API_SUCCESS';
export const GET_POLICY_EXTERNAL_LINKS_API_ERROR = 'GET_POLICY_EXTERNAL_LINKS_API_ERROR';